import { BaseDto } from "../common/baseDto";

export interface EqmInspectResultHeaderDto extends BaseDto {
	inspectNo: string;           // 점검ID(기본키)
	compCd: string;              // 사업장
	compNm: string;              // 사업장명
	equipmentCd: string;         // 설비코드
	equipmentNm: string;         // 설비명
	inspectDt: string | undefined; // 점검일자
	inspectCycle: string;        // 점검주기
	inspectCycleNm: string;      // 점검주기명
	judgeResult: string;         // 판정결과(OK/NG)
	judgeResultNm: string;       // 판정결과명
	judgeEmpno: string;          // 판정자
	judgeEmpNm: string;          // 판정자명
	approvorEmpno: string;       // 승인자
	approvorEmpNm: string;       // 승인자명
	remark: string;              // 비고

	inserted: boolean;
	isModified: boolean;
}

export const defaultEqmInspectResultHeaderDto: EqmInspectResultHeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: "",
	compCd: "",
	compNm: "",
	equipmentCd: "",
	equipmentNm: "",
	inspectDt: undefined,
	inspectCycle: "",
	inspectCycleNm: "",
	judgeResult: "",
	judgeResultNm: "",
	judgeEmpno: "",
	judgeEmpNm: "",
	approvorEmpno: "",
	approvorEmpNm: "",
	remark: "",

	inserted: false,
	isModified: false,
};

export interface EqmInspectResultDetailDto extends BaseDto {
	inspectNo: string;           // 점검no
	itemNo: string;              // 항번 = 점검코드(inspect_cd)
	compCd: string;              // 사업장
	equipmentCd: string;         // 설비코드
	inspectCd: string;           // 점검코드
	inspectCycle: string;        // 점검주기
	inspectDt: string | undefined; // 점검일자
	inspectMethod: string;       // 점검방법
	standardValue: string;       // 기준치
	inspectValue: string;        // 점검결과값
	inspectValue2: string;       // 점검결과값2
	judgeResult: string;         // 판정결과(OK/NG)
	judgeResultNm: string;       // 판정결과명
	judgeEmpno: string;          // 판정자
	judgeEmpNm: string;          // 판정자명
	actionResult: string;        // 조치내용
	remark: string;              // 비고

	// 점검기준 조인 필드 (eqm_inspect_spec)
	inspectNm: string;           // 점검명
	inspectType: string;         // 점검유형 (점검.세척.검교정)
	inspectTypeNm: string;       // 점검유형명
	valueType: string;           // 결과유형 (문자.숫자.OK)
	valueTypeNm: string;         // 결과유형명

	inserted: boolean;
	isModified: boolean;
}

export const defaultEqmInspectResultDetailDto: EqmInspectResultDetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	inspectNo: "",
	itemNo: "",
	compCd: "",
	equipmentCd: "",
	inspectCd: "",
	inspectCycle: "",
	inspectDt: undefined,
	inspectMethod: "",
	standardValue: "",
	inspectValue: "",
	inspectValue2: "",
	judgeResult: "",
	judgeResultNm: "",
	judgeEmpno: "",
	judgeEmpNm: "",
	actionResult: "",
	remark: "",

	inspectNm: "",
	inspectType: "",
	inspectTypeNm: "",
	valueType: "",
	valueTypeNm: "",

	inserted: false,
	isModified: false,
};
